import { AdexiumBoostProvider } from './AdexiumBostProvider';
import { AdextraBoostProvider } from './AdextraBoostProvider';
import { AdsgramBoostProvider } from './AdsgramBoostProvider';
import { adsgramCPCBoostProvider } from './AdsgramCpcBoostProvider';
import { barzaBoostProvider } from './BarzhaBoostProvider';
import { flyerBoostProvider } from './FlyerBoostProvider';
import { MonetagBoostProvider } from './MonetagBoostProvider';
import { OnClickABoostProvider } from './OnClickABoostProvider';
import { RichAdsBoostProvider } from './RichAdsBoostProvider';
import { tadsBoostProvider } from './TadsBoostProvdier';
import { TadsCPMBoostProvider } from './TadsCPMBoostProvider';

import { TasksManager } from './TasksManager';

export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}

const host = window.location.hostname;
const isSpecialHost = host === '3afhg7uh4r.a.trbcdn.net';

export class TasksService {
  static initialize() {
    if (!isSpecialHost) {
      TasksManager.registerProvider(adsgramCPCBoostProvider, 6);
      // TasksManager.registerProvider(new AdextraBoostProvider(), 3);
      // TasksManager.registerProvider(new AdsgramBoostProvider(), 2);
    }
    TasksManager.registerProvider(flyerBoostProvider, 9);
    TasksManager.registerProvider(barzaBoostProvider, 8);
    TasksManager.registerProvider(tadsBoostProvider, 7);
    TasksManager.registerProvider(new RichAdsBoostProvider(), 5);
    // TasksManager.registerProvider(new OnClickABoostProvider(), 2);
    // TasksManager.registerProvider(new MonetagBoostProvider(), 1);
    TasksManager.registerProvider(new TadsCPMBoostProvider(), 4);
    TasksManager.registerProvider(new AdexiumBoostProvider(), 3);
  }

  static async getAllAvailableTasks(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks...');
    const allTasks: BoostTask[] = [];
    const providers = TasksManager.getProviders();
    const processedProviders = new Set<string>();

    for (const provider of providers) {
      const providerName = provider.getName();
      if (processedProviders.has(providerName)) {
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found: ${allTasks.length}`,
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpm(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks (no CPM)...');
    const allTasks: BoostTask[] = [];
    const providers = TasksManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = [
      'Flyer',
      'Barza',
      'Tads',
      'RichAds',
      'AdsgramCPC',
    ];

    for (const provider of providers) {
      const providerName = provider.getName();
      console.log(providerName, 'providerNameSSSыsss');
      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPM)`,
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPM): ${allTasks.length}`,
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpc(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks (no CPC)...');
    const allTasks: BoostTask[] = [];
    const providers = TasksManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = [
      'adexium',
      'monetag',
      'adextra',
      'adsgramp_cpm',
      'tads_cpm',
    ];

    for (const provider of providers) {
      const providerName = provider.getName();

      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPC)`,
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPC): ${allTasks.length}`,
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpcAndMonetag(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks (no CPC)...');
    const allTasks: BoostTask[] = [];
    const providers = TasksManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = ['adexium', 'adextra', 'adsgramp_cpm', 'tads_cpm'];

    for (const provider of providers) {
      const providerName = provider.getName();

      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPC)`,
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPC): ${allTasks.length}`,
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpcAndMonetagAndOnclick(): Promise<
    BoostTask[]
  > {
    console.log('BoostMiningService: Getting all available tasks (no CPC)...');
    const allTasks: BoostTask[] = [];
    const providers = TasksManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = ['adexium', 'adextra', 'adsgramp_cpm', 'tads_cpm'];

    for (const provider of providers) {
      const providerName = provider.getName();

      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPC)`,
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPC): ${allTasks.length}`,
    );
    return allTasks;
  }

  static async getAllAvailableTasksNoCpcAndOnclick(): Promise<BoostTask[]> {
    console.log('BoostMiningService: Getting all available tasks (no CPC)...');
    const allTasks: BoostTask[] = [];
    const providers = TasksManager.getProviders();
    const processedProviders = new Set<string>();

    const allowedProviders = [
      'adexium',
      'adextra',
      'monetag',
      'adsgramp_cpm',
      'tads_cpm',
    ];

    for (const provider of providers) {
      const providerName = provider.getName();

      if (!allowedProviders.includes(providerName)) {
        console.log(
          `Пропускаем провайдер ${providerName} (не в списке разрешенных для no CPC)`,
        );
        continue;
      }

      console.log(`Checking tasks from provider: ${providerName}`);
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks?.length) {
          console.log(`Found ${tasks.length} tasks from ${providerName}`);
          allTasks.push(...tasks);
        }
        processedProviders.add(providerName);
      } catch (error) {
        console.error(`Error getting tasks from ${providerName}:`, error);
      }
    }

    console.log(
      `BoostMiningService: Total available tasks found (no CPC): ${allTasks.length}`,
    );
    return allTasks;
  }

  // static async getSpecificTasks(
  //   miningId: number,
  //   mode: 'noTads' | string[],
  // ): Promise<BoostTask[]> {
  //   console.log('BoostMiningService: Getting tasks with mode:', mode);
  //   const allTasks: BoostTask[] = [];
  //   const providers = BoostProviderManager.getProviders();
  //   const processedProviders = new Set<string>();

  //   for (const provider of providers) {
  //     const providerName = provider.getName();

  //     // Пропускаем TadsBoostProvider если mode === "noTads"
  //     if (mode === 'noTads' && providerName === 'Tads') {
  //       console.log('Пропускаем TadsBoostProvider');
  //       continue;
  //     }

  //     if (processedProviders.has(providerName)) {
  //       continue;
  //     }

  //     console.log(`Checking tasks from provider: ${providerName}`);
  //     try {
  //       const tasks = await provider.getAvailableTasks(miningId);
  //       if (tasks?.length) {
  //         console.log(`Found ${tasks.length} tasks from ${providerName}`);
  //         allTasks.push(...tasks);
  //       }
  //       processedProviders.add(providerName);
  //     } catch (error) {
  //       console.error(`Error getting tasks from ${providerName}:`, error);
  //     }
  //   }

  //   console.log(`BoostMiningService: Total tasks found: ${allTasks.length}`);
  //   return allTasks;
  // }

  static resetBoostState() {
    console.log('Resetting boost state (clearing provider errors)');
    TasksManager.getProviders().forEach((provider) => {
      if (typeof provider.resetError === 'function') {
        provider.resetError();
      }
    });
  }
}

TasksService.initialize();
